//import firebase from 'firebase';
//import 'firebase/auth';

import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
//import { getFirestore } from 'firebase/firestore';
import 'firebase/firestore';
import { getFirestore, collection, getDocs, query, getDoc, addDoc, doc, setDoc } from 'firebase/firestore';

import { firestoreDb, cloudStorage } from './firebaseConfiguration';

export const writeSongToFirestore = (songArtist, songTitle, songFile) => {
  // Organize the song artist and song title into an object.
  const song = {
    songTitle,
    songFileName: songFile.name
  };

  const auth = getAuth(firebaseApp); // Get the auth instance
  //firebase.auth().onAuthStateChanged((user) => {
  onAuthStateChanged(auth, async(user) => {
    if (user) {
      try{
        // Get the collection of songs for the current user.
        //const songsCollection = firestoreDb.collection(`users/${user.uid}/songs`);

        // Get the collection reference for songs for the current user.
        const songsCollectionRef = collection(firestoreDb, `users/${user.uid}/songs`);

        /* // Add the song to a document in the songs collection and log the document id.
        songsCollection.add(song)
          .then((docRef) => {
            console.log('Song document Id: ', docRef.id);
            saveSongFile(user.uid, docRef.id, songFile);
          })
          .catch((error) => console.error('There was an error while writing a song to firestore: ', error));
        */

        // Add the song to a document in the songs collection.
        // MODULAR CHANGE: Use addDoc() function, pass collection reference and data
        const docRef = await addDoc(songsCollectionRef, song);

        console.log('Song document Id: ', docRef.id);
        // Assuming saveSongFile is an async function that handles file upload
        // and returns a Promise, you might want to await it.
        saveSongFile(user.uid, docRef.id, songFile);

        /* // Add artist to user doc if artist exists
        if (songArtist) {
          const userDocument = firestoreDb.doc(`users/${user.uid}`);
          userDocument.set({
            artistName: songArtist
          });
        }*/

        // Add artist to user doc if artist exists
        if (songArtist) {
          // MODULAR CHANGE: Use doc() function, pass db instance and document path
          const userDocumentRef = doc(firestoreDb, `users/${user.uid}`);

          // Use setDoc for clarity when setting specific fields,
          // or updateDoc if you want to update existing fields without overwriting the whole document.
          // Since you're using set, and likely just setting one field, setDoc is appropriate.
          await setDoc(userDocumentRef, { artistName: songArtist }, { merge: true }); // Added { merge: true } to prevent overwriting existing user data
        }
      } catch (error) {
        console.error('There was an error while writing a song to firestore: ', error);
      }
    }
  });
}

export const saveSongFile = (userId, docRefId, songFile) => {
  // Create a reference to the file path in Cloud Storage.
  // MODULAR CHANGE: Use ref() function, passing the storage instance and path
  const storageRef = ref(storage, `songs/${userId}/${docRefId}-${songFile.name}`);

  // Upload the file to Cloud Storage.
  // MODULAR CHANGE: Use uploadBytesResumable() function, passing the storageRef and file
  const uploadTask = uploadBytesResumable(storageRef, songFile);

  // The returned task can indicate changes in the state of the file upload.
  // The .on() method remains similar, but uses the imported TaskEvent.STATE_CHANGED
  uploadTask.on(TaskEvent.STATE_CHANGED, // Use TaskEvent.STATE_CHANGED
    // The progress function can indicate how many bytes have been transferred to Cloud Storage.
    (snapshot) => { // Use arrow function for cleaner syntax
      console.log('Bytes transferred: ', snapshot.bytesTransferred);
      console.log('Total bytes: ', snapshot.totalBytes);
      // Calculate percentage if needed
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log(`Upload is ${progress}% done`);

      // You can also check upload state here:
      switch (snapshot.state) {
        case 'paused':
          console.log('Upload is paused');
          break;
        case 'running':
          console.log('Upload is running');
          break;
      }
    },

    // The error function will be called if there is an error while the file is uploading.
    (error) => { // Use arrow function for cleaner syntax
      console.error('There was an error while saving to Cloud Storage: ', error);
      // Handle specific storage errors more granularly if needed
      // switch (error.code) {
      //   case 'storage/unauthorized':
      //     // User doesn't have permission to access the object
      //     break;
      //   case 'storage/canceled':
      //     // User canceled the upload
      //     break;
      //   // ... other error codes
      //   case 'storage/unknown':
      //     // Unknown error occurred, inspect error.serverResponse
      //     break;
      // }
    },

    // The complete function will be called once the upload has completed successfully.
    () => { // Use arrow function for cleaner syntax, no arguments for complete
      console.log('File successfully saved to Cloud Storage');
      // You can get the download URL here if needed (after upload is complete)
      // getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
      //   console.log('File available at', downloadURL);
      // });
    }
  );
};

export const readSongsFromFirestore = async (userId) => { // Make the function async
  try {
    // Await the result of getArtistName, assuming it's an async operation
    const songArtist = await getArtistName(userId);

    const songs = [];

    // MODULAR CHANGE: Get the collection reference using the collection() function
    const songsCollectionRef = collection(firestoreDb, `users/${userId}/songs`);

    // MODULAR CHANGE: Get all song documents from the song collection using getDocs()
    const querySnapshot = await getDocs(songsCollectionRef); // Await the promise from getDocs()

    querySnapshot.forEach((doc) => {
      // Spread doc.data() to get the fields, add 'id' and 'songArtist'
      const songData = { ...doc.data(), id: doc.id, songArtist };
      songs.push(songData);
    });

    return songs; // The async function automatically wraps the return value in a Promise
  } catch (error) {
    console.error('Error reading songs from Firestore:', error);
    // Re-throw the error so the caller can handle it
    throw error;
  }
};

export const deleteSongFromFirestore = (songId) => {
  // We'll keep the outer Promise wrapper here since onAuthStateChanged is asynchronous
  // and we want to resolve/reject the outer Promise based on its internal outcome.
  return new Promise((resolve, reject) => { // Added reject for error handling
    const auth = getAuth(firebaseApp);

    onAuthStateChanged(auth, async (user) => { // Made the callback async
      if (user) {
        try {
          // MODULAR CHANGE: Get the document reference using the doc() function
          const songDocumentRef = doc(firestoreDb, `users/${user.uid}/songs/${songId}`);

          // MODULAR CHANGE: Use the deleteDoc() function to delete the document
          await deleteDoc(songDocumentRef); // Await the deletion

          console.log(`The song with an id of ${songId} has been deleted successfully`);
          resolve(); // Resolve the outer Promise on success
        } catch (error) {
          console.error(`There was an error while trying to delete song with id ${songId}:`, error);
          reject(error); // Reject the outer Promise on error
        }
      } else {
        // Handle case where user is not logged in (e.g., if onAuthStateChanged fires for null user)
        console.warn('Cannot delete song: User is not authenticated.');
        reject(new Error('User not authenticated.'));
      }
    });
  });
};

export const getSongFromFirestore = (songId) => {
  // We'll keep the outer Promise wrapper to handle the async nature of onAuthStateChanged
  // and control when the outer Promise resolves or rejects.
  return new Promise((resolve, reject) => { // Added reject for proper error handling
    const auth = getAuth(firebaseApp);

    onAuthStateChanged(auth, async (user) => { // Made the callback async
      if (user) {
        try {
          // MODULAR CHANGE: Get the document reference using the doc() function
          const songDocumentRef = doc(firestoreDb, `users/${user.uid}/songs/${songId}`);

          // MODULAR CHANGE: Get the song data from Firestore using getDoc()
          const docSnapshot = await getDoc(songDocumentRef); // Await the document fetch

          if (docSnapshot.exists()) {
            const songData = { ...docSnapshot.data(), id: docSnapshot.id };
            resolve(songData); // Resolve the outer Promise with the song data
          } else {
            console.log(`No song found with ID: ${songId}`);
            resolve(null); // Resolve with null or undefined if the song doesn't exist
          }
        } catch (error) {
          console.error(`There was an error while trying to get song with id ${songId}:`, error);
          reject(error); // Reject the outer Promise on error
        }
      } else {
        // Handle case where user is not logged in (e.g., if onAuthStateChanged fires for null user)
        console.warn('Cannot get song: User is not authenticated.');
        reject(new Error('User not authenticated.'));
      }
    });
  });
};

export const updateSongInFirebase = (song) => {
  const auth = getAuth(firebaseApp);

  onAuthStateChanged(auth, async (user) => { // Made the callback async
    if (user) {
      try {
        // MODULAR CHANGE: Get the document reference using the doc() function
        const songDocumentRef = doc(firestoreDb, `users/${user.uid}/songs/${song.id}`);

        // Create the object with fields to update
        const updatedSongData = {
          songTitle: song.songTitle
          // Add any other fields you want to update here, e.g.,
          // songDuration: song.songDuration,
        };

        // MODULAR CHANGE: Use the updateDoc() function to update the document
        // This will update only the specified fields, leaving others untouched.
        await updateDoc(songDocumentRef, updatedSongData); // Await the update operation

        console.log('Your song was updated successfully:', song);
      } catch (error) {
        console.error('There was an error while updating your song:', song, error);
      }
    } else {
      console.warn('Cannot update song: User is not authenticated.');
    }
  });
};

export const getAudioFromStorage = async (userId, fileName) => { // Make the function async
  try {
    // MODULAR CHANGE: Get the storage instance (if not already global, or pass it in)
    // Assuming 'storage' (from getStorage(firebaseApp)) is available in this scope.
    // If not, you might need: const storage = getStorage(firebaseApp); here.

    // MODULAR CHANGE: Get the reference to the file in Cloud Storage using ref()
    const fileRef = ref(storage, `songs/${userId}/${fileName}`);

    // MODULAR CHANGE: Get the URL for the song file in Cloud Storage using getDownloadURL()
    const url = await getDownloadURL(fileRef); // Await the download URL

    return url; // The async function automatically wraps the return value in a Promise
  } catch (error) {
    console.error('There was an error while retrieving a file from Cloud Storage:', error);
    // Re-throw the error so the caller can handle it, or return null/undefined as appropriate.
    throw error;
  }
};

export const getArtistName = async (userId) => { // Make the function async
  try {
    // MODULAR CHANGE: Get reference to the user document using doc()
    const userDocumentRef = doc(firestoreDb, `users/${userId}`);

    // MODULAR CHANGE: Get the user's artist name using getDoc()
    const docSnapshot = await getDoc(userDocumentRef); // Await the document fetch

    if (docSnapshot.exists()) {
      // Return the artistName directly if the document exists
      return docSnapshot.data().artistName;
    } else {
      console.log(`No user document found for ID: ${userId}`);
      return null; // Return null if the user document doesn't exist
    }
  } catch (error) {
    console.error(`Error getting artist name for user ${userId}:`, error);
    // Re-throw the error so the caller can handle it
    throw error;
  }
};

export const getAllArtists = async () => { // Make the function async
  try {
    const artists = [];

    // MODULAR CHANGE: Get the collection reference using the collection() function
    const userCollectionRef = collection(firestoreDb, 'users');

    // MODULAR CHANGE: Get all user documents using getDocs()
    const querySnapshot = await getDocs(userCollectionRef); // Await the query snapshot

    querySnapshot.forEach((docRef) => {
      // Spread docRef.data() to get the fields, add 'id'
      const artist = { ...docRef.data(), id: docRef.id };
      artists.push(artist);
    });

    return artists; // The async function automatically wraps the return value in a Promise
  } catch (error) {
    console.error('Error getting all artists from Firestore:', error);
    // Re-throw the error so the caller can handle it
    throw error;
  }
};

export const saveCommentToFirestore = (commentText, songId) => {
  const auth = getAuth(firebaseApp);

  onAuthStateChanged(auth, async (user) => { // Made the callback async
    if (user) {
      try {
        // MODULAR CHANGE: Get the collection reference using the collection() function
        const commentCollectionRef = collection(firestoreDb, `comments`);

        const userName = user.displayName ? user.displayName : 'Anonymous';

        const newCommentData = {
          userId: user.uid,
          userName,
          songId,
          commentText,
          date: Date.now() // Or use serverTimestamp() for best practice if rules allow
        };

        // MODULAR CHANGE: Add the comment using the addDoc() function
        const docRef = await addDoc(commentCollectionRef, newCommentData);

        console.log('Comment successfully added to firestore with ID:', docRef.id);
      } catch (error) {
        console.error('There was an error when trying to add your comment to firestore: ', error);
      }
    } else {
      console.warn('Cannot save comment: User is not authenticated.');
    }
  });
};

export const getCommentsForSong = async (songId) => { // Make the function async
  try {
    const comments = [];

    // MODULAR CHANGE: Get the collection reference using the collection() function
    const commentsCollectionRef = collection(firestoreDb, 'comments');

    // MODULAR CHANGE: Build the query using query() and where()
    const q = query(commentsCollectionRef, where("songId", "==", songId));

    // MODULAR CHANGE: Execute the query using getDocs()
    const querySnapshot = await getDocs(q); // Await the query snapshot

    querySnapshot.forEach((commentDoc) => { // Renamed 'comment' to 'commentDoc' for clarity
      comments.push(commentDoc.data());
    });

    return comments; // The async function automatically wraps the return value in a Promise
  } catch (error) {
    console.error('Error getting comments for song:', songId, error);
    // Re-throw the error so the caller can handle it
    throw error;
  }
};
